import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    readAllLocations,
    createLocation,
    updateLocation,
    deleteLocation,
    readAllWarehouses
} from '../../helpers';
import {
    locationsApiResponseSuccess,
    locationsApiResponseError,
    locationsGetAllLocations,
} from './actions';
import { LocationsActionTypes } from './constants';
import {
    locationResponseToLocationObject,
    locationObjectToLocationRequest,
} from '../../helpers/mappers/location';

export function* readAllLocationsSaga({ payload: { query } }) {
    try {
        const response = yield call(readAllLocations, query);
        const warehousesResponse = yield call(readAllWarehouses, null);
        const locationEntries = response.data.map((locationResponse) =>
            locationResponseToLocationObject(locationResponse, warehousesResponse.data)
        );
        yield put(locationsApiResponseSuccess(LocationsActionTypes.READ_ALL_LOCATIONS_REQUEST, locationEntries));
    } catch (error) {
        yield put(locationsApiResponseError(LocationsActionTypes.READ_ALL_LOCATIONS_REQUEST, error));
    }
}

export function* createLocationSaga({ payload: { location, callback } }) {
    try {
        const locationRequest = locationObjectToLocationRequest(location);
        const response = yield call(createLocation, locationRequest);
        const locationResponse = locationResponseToLocationObject(response);
        yield put(locationsApiResponseSuccess(LocationsActionTypes.CREATE_LOCATION_REQUEST, locationResponse));
        yield put(locationsGetAllLocations());
    } catch (error) {
        yield put(locationsApiResponseError(LocationsActionTypes.CREATE_LOCATION_REQUEST, error));
    } finally {
        callback?.();
    }
}

function* updateLocationSaga({ payload: { locationId, location } }) {
    try {
        const locationRequest = locationObjectToLocationRequest(location);
        const response = yield call(updateLocation, locationId, locationRequest);
        const locationResponse = locationResponseToLocationObject(response);
        yield put(locationsApiResponseSuccess(LocationsActionTypes.UPDATE_LOCATION_REQUEST, locationResponse));
        yield put(locationsGetAllLocations());
    } catch (error) {
        yield put(locationsApiResponseError(LocationsActionTypes.UPDATE_LOCATION_REQUEST, error));
    }
}

function* deleteLocationSaga({ payload: { locationId } }) {
    try {
        // response should be HTTP success with empty body
        const response = yield call(deleteLocation, locationId);
        yield put(locationsApiResponseSuccess(LocationsActionTypes.DELETE_LOCATION_REQUEST, response));
        yield put(locationsGetAllLocations());
    } catch (error) {
        yield put(locationsApiResponseError(LocationsActionTypes.DELETE_LOCATION_REQUEST, error));
    }
}

export function* watchReadAllLocationsSaga() {
    yield takeLatest(LocationsActionTypes.READ_ALL_LOCATIONS_REQUEST, readAllLocationsSaga);
}

export function* watchCreateLocationSaga() {
    yield takeLatest(LocationsActionTypes.CREATE_LOCATION_REQUEST, createLocationSaga);
}

export function* watchUpdateLocationSaga() {
    yield takeLatest(LocationsActionTypes.UPDATE_LOCATION_REQUEST, updateLocationSaga);
}

export function* watchDeleteLocationSaga() {
    yield takeLatest(LocationsActionTypes.DELETE_LOCATION_REQUEST, deleteLocationSaga);
}

function* locationsSaga() {
    yield all([
        fork(watchReadAllLocationsSaga),
        fork(watchCreateLocationSaga),
        fork(watchUpdateLocationSaga),
        fork(watchDeleteLocationSaga),
    ]);
}

export default locationsSaga;
